import { useGetProjectByIdQuery } from 'src/services';
import { useParams } from 'react-router-dom';
import { IntegrationsModal } from 'src/pages/ControlDeskPage/IntegrationStatusSection/IntegrationsModal/IntegrationsModal';
import React, { forwardRef } from 'react';
import { clsx } from 'clsx';
import { Button } from 'src/components/ui/button';
import { useAppSelector } from 'src/store';
import { DialogTrigger } from '@radix-ui/react-dialog';
import { phEvent } from 'src/utils/posthog.utils';
import { WarningPopover } from 'src/components/WarningPopower/WarningPopover';
import { useGetUsersMeQuery } from 'src/services/usersService';
import { INTEGRATION_ACCESS_ROLES } from 'src/constants/roles';

const ConnectHelpdeskButton = forwardRef(
  (
    { disabled = false, visible = true }: { disabled?: boolean; visible?: boolean },
    ref: React.Ref<HTMLButtonElement>,
  ) => {
    const onClick = () => {
      phEvent('connect_helpdesk_button_clicked');
    };

    return (
      <DialogTrigger disabled={!visible} asChild>
        <Button
          ref={ref}
          disabled={disabled}
          variant="green"
          size="xl"
          className={clsx(!visible && 'pointer-events-none opacity-50')}
          onClick={onClick}
        >
          <p className="font-bold text-sm">Connect Helpdesk</p>
        </Button>
      </DialogTrigger>
    );
  },
);

export const ConnectYouAIAgentBanner = () => {
  const { id } = useParams();
  const { data: currentProject } = useGetProjectByIdQuery({ id: id });
  const { isInactivePlan } = useAppSelector((s) => s.planSlice);
  const { data: userInfo } = useGetUsersMeQuery();
  const isIntegrationAllowed = INTEGRATION_ACCESS_ROLES.includes(userInfo?.role);
  const isButtonDisabled = !isIntegrationAllowed || !currentProject?.is_active || isInactivePlan;

  if (currentProject?.integrations?.length) {
    return null;
  }

  return (
    <div
      className={
        'w-full flex flex-row items-center justify-between py-5 px-7 border border-[#389D6140] bg-[#E4FFEC] rounded-sm-5'
      }
    >
      <div className={'flex flex-col gap-1'}>
        <p className={'text-xl font-bold text-[#0E873F]'}>Connect your AI agent</p>
        <p className={'text-sm font-medium text-[#0E873F]'}>
          Your agent is verified and ready. Link it to your helpdesk to go live when you’re ready.
        </p>
      </div>
      <div className={'relative flex flex-col'}>
        <IntegrationsModal
          trigger={<ConnectHelpdeskButton disabled={isButtonDisabled} />}
          visible={true}
          disabled={!isIntegrationAllowed}
        />
        {!isIntegrationAllowed && (
          <WarningPopover triggerClassName="absolute -right-2 -top-2" fill="black" />
        )}
      </div>
    </div>
  );
};
